module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AddToCart":{"button":"Koupit","variantRequired":"Prosím vyberte variantu","notAvailable":"Není skladem"}}}')
  delete Component.options._Ctor
}
